import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { HiOutlineChevronDoubleRight } from "react-icons/hi";
import { Link } from "react-router-dom";

export default function CustomBreadcrumbs(props: any) {

    const path: {path: string, title: string}[] | undefined = props.path
    const page: string | undefined = props.page

    const pathCrumbs = path?.map((pathElement, index) => {
        return (
            <React.Fragment key={`breadcrumb-${index}`}>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: pathElement.path }}>{pathElement.title}</Breadcrumb.Item>
            {index < path.length - 1 && <Breadcrumb.Item active><HiOutlineChevronDoubleRight /></Breadcrumb.Item>}
            </React.Fragment>
        )
    })

    return (
        <Breadcrumb>
            {pathCrumbs}
            {pathCrumbs && pathCrumbs.length > 0 && (
                <Breadcrumb.Item active><HiOutlineChevronDoubleRight /></Breadcrumb.Item>
            )}
            <Breadcrumb.Item active className="breadcrumbs-active">{page}</Breadcrumb.Item>
        </Breadcrumb>
    )
}